import { render } from "./PerformancesContent.vue?vue&type=template&id=41d56fe0&ts=true"
import script from "./PerformancesContent.vue?vue&type=script&lang=ts"
export * from "./PerformancesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__